import { render, staticRenderFns } from "./MoreAttributes.vue?vue&type=template&id=91e387c4&"
import script from "./MoreAttributes.vue?vue&type=script&lang=ts&"
export * from "./MoreAttributes.vue?vue&type=script&lang=ts&"
import style0 from "./MoreAttributes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports